"use strict";

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlaygroundStorage = function () {
    function PlaygroundStorage(projectId) {
        this.storages = {};
        this.projectId = projectId;
        this.project = this.getProject();
        this.executedQueryCount = this.getExecutedQueryCount();
        if (!this.project) {
            this.project = {
                sessions: {},
                history: [],
                data: {}
            };
            this.saveProject();
        }
        global['s'] = this;
    }
    PlaygroundStorage.prototype.executedQuery = function () {
        if (!this.executedQueryCount) {
            this.executedQueryCount = 1;
        } else {
            this.executedQueryCount++;
        }
    };
    PlaygroundStorage.prototype.hasExecutedQuery = function () {
        return this.executedQueryCount >= 2;
    };
    PlaygroundStorage.prototype.getSessionStorage = function (sessionId) {
        if (this.storages[sessionId]) {
            return this.storages[sessionId];
        }
        var prefix = this.projectId + ":" + sessionId + ":";
        var store = {
            clear: function clear() {
                Object.keys(localStorage).filter(function (key) {
                    return key.startsWith(prefix);
                }).forEach(function (key) {
                    return localStorage.removeItem(key);
                });
            },
            getItem: function getItem(key) {
                return localStorage.getItem(prefix + key);
            },
            setItem: function setItem(key, item) {
                return localStorage.setItem(prefix + key, item);
            },
            removeItem: function removeItem(key) {
                return localStorage.removeItem(prefix + key);
            }
        };
        this.storages[sessionId] = store;
        return store;
    };
    PlaygroundStorage.prototype.getSessions = function () {
        var _this = this;
        return Object.keys(this.project.sessions).filter(function (key) {
            return key !== 'undefined';
        }).map(function (sessionId) {
            return _this.project.sessions[sessionId];
        });
    };
    PlaygroundStorage.prototype.removeSession = function (session) {
        delete this.project.sessions[session.id];
    };
    PlaygroundStorage.prototype.saveSession = function (session, save) {
        if (save === void 0) {
            save = false;
        }
        this.project.sessions[session.id] = session;
        if (save) {
            this.saveProject();
        }
    };
    PlaygroundStorage.prototype.syncHistory = function (history) {
        this.project.history = history;
    };
    PlaygroundStorage.prototype.addToHistory = function (session) {
        // limit by 1000 items
        this.project.history.unshift(session);
        this.project.history = this.project.history.slice(0, 1000);
    };
    PlaygroundStorage.prototype.getHistory = function () {
        return this.project.history || [];
    };
    PlaygroundStorage.prototype.setItem = function (key, value) {
        this.project.data[key] = value;
    };
    PlaygroundStorage.prototype.getItem = function (key) {
        return this.project.data[key];
    };
    PlaygroundStorage.prototype.saveProject = function () {
        var json = JSON.stringify(this.project);
        localStorage.setItem(this.projectId, json);
        localStorage.setItem('executedQueryCount', this.executedQueryCount.toString());
    };
    PlaygroundStorage.prototype.getProject = function () {
        var result = null;
        try {
            result = JSON.parse(localStorage.getItem(this.projectId) || '');
        } catch (e) {
            //
        }
        if (result && result.history) {
            result.history = result.history.map(function (item) {
                return __assign({}, item, { date: new Date(item.date) });
            });
        }
        return result;
    };
    PlaygroundStorage.prototype.getExecutedQueryCount = function () {
        var count = 0;
        try {
            count = parseInt(localStorage.getItem('executedQueryCount') || '0', 10);
        } catch (e) {
            //
        }
        return count;
    };
    return PlaygroundStorage;
}();
exports.default = PlaygroundStorage;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/PlaygroundStorage.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/PlaygroundStorage.js
// module chunks = 0